import React, { useEffect, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import Pettcashdetailtab from "../pettycash/Pettcashdetailtab";
import { useSelector } from "react-redux";
import DashboardSkeleton from "../../common/DashboardSkeleton";

const Pettycashdashboard = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [pettycashData, setPettyCashData] = useState([]);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [openRow, setOpenRow] = useState(null);
  const [city, setCity] = useState("");
  const [hub, setHub] = useState("");
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const ledgerRecords = pettycashData?.list || [];
  const totalRecords = ledgerRecords.length;
  const totalPages = Math.max(1, Math.ceil(totalRecords / rowsPerPage));
  const displayedRecords = ledgerRecords.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  const startRecord = totalRecords === 0 ? 0 : page * rowsPerPage + 1;
  const endRecord = Math.min((page + 1) * rowsPerPage, totalRecords);
  const [loading, setLoading] = useState(false);

  const toggleDrawer = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  function formatDateForApi(date, type) {
    if (!date) return "";
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    let hours = type === "start" ? "00" : "23";
    let minutes = type === "start" ? "00" : "59";
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  useEffect(() => {
    if (page > totalPages - 1) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [page, totalPages]);

  const getAllHubsList = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data?.statusCode === "0100")
        setGetAllHubsListData(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const getPettyCashDetails = async (
    selectedCity = city,
    selectedHub = hub,
    selectedRange = selectionRange,
  ) => {
    const formattedStartDate = formatDateForApi(
      selectedRange?.startDate,
      "start",
    );
    const formattedEndDate = formatDateForApi(selectedRange?.endDate, "end");
    const queryParts = [];
    if (selectedCity) {
      queryParts.push(`cityId=${selectedCity}`);
    }
    if (selectedHub) {
      queryParts.push(`hubId=${selectedHub}`);
    }
    const queryString = queryParts.length ? `&${queryParts.join("&")}` : "";
    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/expense-petty-cash-dashboard?startDate=${formattedStartDate}&endDate=${formattedEndDate}${queryString}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setPettyCashData(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  useEffect(() => {
    getPettyCashDetails();
    getAllHubsList();
  }, []);

  const dashboardSections = [
    {
      title: "Expense Categories",
      iconBg: "bg-blue-600",
      gridView: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-8",
      cards: [
        {
          title: "Office Expense",
          value: pettycashData?.officeExpenseCount,
          sub: "Count",
        },
        {
          title: "Office Amount",
          value: pettycashData?.officeExpenseAmount,
          sub: "Amount",
        },

        {
          title: "Fuel Charges",
          value: pettycashData?.fuelChargesCount,
          sub: "Count",
        },
        {
          title: "Fuel Amount",
          value: pettycashData?.fuelChargesAmount,
          sub: "Amount",
        },

        {
          title: "Vehicle Expense",
          value: pettycashData?.vehicleExpensesCount,
          sub: "Count",
        },
        {
          title: "Vehicle Amount",
          value: pettycashData?.vehicleExpensesAmount,
          sub: "Amount",
        },

        {
          title: "Pickup & Delivery",
          value: pettycashData?.pickupAndDeliveryReimbursementCount,
          sub: "Count",
        },
        {
          title: "Pickup Amount",
          value: pettycashData?.pickupAndDeliveryReimbursementAmount,
          sub: "Amount",
        },

        { title: "Others", value: pettycashData?.othersCount, sub: "Count" },
        {
          title: "Others Amount",
          value: pettycashData?.othersAmount,
          sub: "Amount",
        },
      ],
    },

    {
      title: "Approval Status",
      iconBg: "bg-red-500",
      gridView: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6",
      cards: [
        {
          title: "Requested",
          value: pettycashData?.requestedCount,
          sub: "Count",
        },
        {
          title: "Requested Amount",
          value: pettycashData?.requestedAmount,
          sub: "Amount",
        },

        {
          title: "Approved",
          value: pettycashData?.verifiedCount,
          sub: "Count",
        },
        {
          title: "Approved Amount",
          value: pettycashData?.verifiedAmount,
          sub: "Amount",
        },       
      ],
    },

    {
      title: "Payment Status",
      iconBg: "bg-green-600",
      gridView: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6",
      cards: [
        // {
        //   title: "Transaction Pending",
        //   value: pettycashData?.transactionPendingCount,
        //   sub: "Count",
        // },
        // {
        //   title: "Pending Amount",
        //   value: pettycashData?.transactionPendingAmount,
        //   sub: "Amount",
        // },

        // {
        //   title: "Verified",
        //   value: pettycashData?.verifiedCount,
        //   sub: "Count",
        // },
        // {
        //   title: "Verified Amount",
        //   value: pettycashData?.verifiedAmount,
        //   sub: "Amount",
        // },

        {
          title: "Cash Completed",
          value: pettycashData?.cashCompletedCount,
          sub: "Count",
        },
        {
          title: "Cash Completed Amount",
          value: pettycashData?.cashCompletedAmount,
          sub: "Amount",
        },
      ],
    },

    {
      title: "Overall Summary",
      iconBg: "bg-purple-600",
      gridView: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-8",
      cards: [
        {
          title: "Grand Total Count",
          value: pettycashData?.grandTotalCount,
          sub: "Total Requests",
        },
        {
          title: "Grand Total Amount",
          value: pettycashData?.grandTotalAmount,
          sub: "Overall Amount",
        },
      ],
    },
  ];

  return (
    <div>
      <div className="my-6">
        <h1 className="flex justify-start text-xl font-semibold">
          Petty cash Dashboard
        </h1>
        <div className="flex gap-4 justify-end">
          <DaterangePicker
            selectionRange={selectionRange}
            setSelectionRange={setSelectionRange}
            style={-10}
          />
          <select
            className="w-40 h-11 px-4 pr-10 border border-gray-300 rounded-lg bg-white text-gray-700 shadow-sm outline-none appearance-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          >
            <option>Select City</option>
            {cities &&
              Object.entries(cities).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
          </select>
          <select
            className="w-40 h-11 px-4 pr-10 border border-gray-300 rounded-lg bg-white text-gray-700 shadow-sm outline-none appearance-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
            value={hub}
            onChange={(e) => setHub(e.target.value)}
          >
            <option>Select Hub</option>
            {getAllHubsListData &&
              getAllHubsListData.map((item, index) => (
                <option key={index} value={item?.id}>
                  {item?.hubName}
                </option>
              ))}
          </select>

          <button
            onClick={() => {
              getPettyCashDetails();
            }}
            className="p-2 bg-blue-400"
          >
            Search
          </button>
          <button
            onClick={() => {
              setCity("");
              setHub("");
              const resetRange = {
                startDate: oneMonthAgo,
                endDate: today,
                key: "selection",
              };
              setSelectionRange(resetRange);
              getPettyCashDetails("", "", resetRange);
            }}
            className="p-2 bg-red-400"
          >
            Clear
          </button>
        </div>
      </div>

      <>
        {loading ? (
          <DashboardSkeleton />
        ) : (
          <>
            <div className="space-y-8">
              {dashboardSections.map((section, index) => (
                <div key={index} className="bg-white rounded-3xl p-5 shadow-sm">
                  {/* Header */}
                  <div className="flex items-center gap-3 border-b-2 border-gray-200 pb-3 mb-5">
                    <div
                      className={`w-10 h-10 rounded-xl ${section.iconBg} flex items-center justify-center text-white font-bold`}
                    >
                      📊
                    </div>

                    <h2 className="text-xl font-semibold">{section.title}</h2>
                  </div>

                  {/* Cards */}
                  <div className={`${section.gridView} gap-5`}>
                    {section.cards.map((card, i) => (
                      <div
                        key={i}
                        className="border rounded-2xl p-5 bg-white shadow-sm hover:shadow-md transition h-44"
                      >
                        <p className="text-gray-500 text-sm font-medium">
                          {card.title}
                        </p>

                        <div className="mt-5 text-center">
                          <h2 className="text-4xl font-bold text-gray-800">
                            {card.value ?? 0}
                          </h2>

                          <p className="text-xs text-gray-400 mt-3">
                            {card.sub}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="rounded-xl shadow-md overflow-x-auto my-4 my-4">
              <table className="min-w-full border-collapse">
                <thead className="bg-gradient-to-r from-indigo-50 to-blue-50 border-b border-gray-200">
                  <tr className="text-xs uppercase tracking-wider text-gray-700">
                    <th className="px-6 py-4 text-left font-semibold">
                      Cash For
                    </th>

                    <th className="px-6 py-4 text-left font-semibold">
                      Petty Cash Status
                    </th>

                    <th className="px-6 py-4 text-left font-semibold">
                      Vehicle Name
                    </th>

                    <th className="px-6 py-4 text-left font-semibold">
                      Registration No
                    </th>

                    <th className="px-6 py-4 text-left font-semibold">
                      Booking Id
                    </th>

                    <th className="px-6 py-4 text-left font-semibold">
                      City Name
                    </th>

                    <th className="px-6 py-4 text-left font-semibold">
                      Created At
                    </th>

                    <th className="px-6 py-4 text-center font-semibold">
                      Approved By
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {displayedRecords.map((record, index) => (
                    <React.Fragment key={record.id}>
                      {/* Main Row */}
                      <tr
                        onClick={() => toggleDrawer(record.id)}
                        className={`cursor-pointer transition-all duration-300 hover:bg-blue-50 ${
                          index % 2 === 0 ? "bg-white" : "bg-gray-50"
                        }`}
                      >
                        <td className="px-6 py-5">{record?.cashFor || "-"}</td>

                        <td className="px-6 py-5">
                          {record?.pettyCashStatus || "-"}
                        </td>

                        <td className="px-6 py-5">
                          <span className="rounded-full bg-indigo-100 px-3 py-1 text-sm font-semibold text-indigo-700">
                            {record.vehicleName || "-"}
                          </span>
                        </td>

                        <td className="px-6 py-5">
                          <span className="rounded-full bg-indigo-100 px-3 py-1 text-sm font-semibold text-indigo-700">
                            {record.registrationNo || "-"}
                          </span>
                        </td>
                        <td className="px-6 py-5">
                          {record?.bookingId || "-"}
                        </td>
                        <td className="px-6 py-5">{record?.cityName || "-"}</td>
                        <td className="px-6 py-5">
                          {record?.createdAt || "-"}
                        </td>
                        <td className="px-6 py-5">
                          {record?.approvedBy || "-"}
                        </td>
                      </tr>

                      {openRow === record.id && (
                        <tr>
                          <td colSpan={7} className="bg-gray-50 p-6">
                            <div className="bg-white rounded-2xl shadow-md border p-6">
                              <h2 className="text-xl font-bold text-gray-800 mb-5 border-b pb-3">
                                Other Details
                              </h2>

                              <div className="grid grid-cols-2 gap-4 text-sm">
                                <div>
                                  <p className="text-gray-500">
                                    Approval Comment
                                  </p>
                                  <p className="font-semibold">
                                    {record.approvalComment}
                                  </p>
                                </div>

                                <div>
                                  <p className="text-gray-500">Attachments</p>
                                </div>

                                <div>
                                  <p className="text-gray-500">Description</p>
                                  <p className="font-semibold">
                                    {record.description}
                                  </p>
                                </div>

                                <div>
                                  <p className="text-gray-500">Requested By</p>
                                  <p>{record?.requestBy}</p>
                                </div>

                                <div>
                                  <p className="text-gray-500">Hub Name</p>
                                  <p>{record?.hubName}</p>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                  {displayedRecords.length === 0 && (
                    <tr>
                      <td
                        colSpan={7}
                        className="px-6 py-8 text-center text-gray-500"
                      >
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="flex flex-col gap-3 border-t border-gray-200 bg-gray-50 px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="text-sm text-gray-600">
                  Showing {startRecord}-{endRecord} of {totalRecords} records
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    disabled={page === 0}
                    onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                    className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition enabled:hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <button
                    type="button"
                    disabled={page >= totalPages - 1}
                    onClick={() =>
                      setPage((prev) => Math.min(prev + 1, totalPages - 1))
                    }
                    className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition enabled:hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default Pettycashdashboard;
